export enum InterventionType {
    INTER1 = "INTER1",
    INTER2 = "INTER2",
    INTER3 = "INTER3",
    STA = "STA"
}
